/**
 * @generated SignedSource<<71997a300dbc3320f73fdc8d75bc50b8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ProjectHeader_inner_project$data = {
  readonly avatar: {
    readonly large: string | null | undefined;
  } | null | undefined;
  readonly canEditProjectConfig: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly created?: AGG$DateTime | null | undefined;
  readonly key: string;
  readonly name: string;
  readonly projectId: string | null | undefined;
  readonly projectType: JiraProjectType;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationInviteButton_project" | "NavigationTeamButton_project" | "ProjectAvatar" | "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs" | "extraComponentsFar_horizontalNav">;
  readonly " $fragmentType": "ProjectHeader_inner_project";
};
export type ProjectHeader_inner_project$key = {
  readonly " $data"?: ProjectHeader_inner_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_inner_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "ProjectHeader_inner_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProjectAvatar"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "NavigationTeamButton_project"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "NavigationInviteButton_project"
        },
        {
          "kind": "ScalarField",
          "name": "created"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectType"
      },
      "action": "THROW",
      "path": "projectType"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "concreteType": "JiraAvatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "large"
        }
      ]
    },
    {
      "alias": "canEditProjectConfig",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "EDIT_PROJECT_CONFIG"
        }
      ],
      "concreteType": "JiraProjectAction",
      "kind": "LinkedField",
      "name": "action",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ],
      "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "extraComponentsFar_horizontalNav"
    },
    {
      "kind": "FragmentSpread",
      "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "46e2bd7da0035f7ca9f261274f8fd3ae";

export default node;
